import { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

export const VoiceInput = ({ onText, className = "" }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const chunks = [];
      const r = new MediaRecorder(stream);
      r.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      r.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        const fd = new FormData();
        fd.append("file", new Blob(chunks, { type: r.mimeType || "audio/webm" }), r.mimeType?.includes("mp4") ? "voice.mp4" : "voice.webm");
        try {
          const res = await http.post("/buddy/transcribe", fd);
          if (res.data.text) onText(res.data.text); else toast.message("I didn't catch that. Try again?");
        } catch { toast.error("Couldn't hear that clearly. Please try again."); }
        setState("idle");
      };
      rec.current = r;
      r.start();
      setState("recording");
    } catch { toast.error("Microphone access is needed to talk out loud."); }
  };

  const click = () => (state === "recording" ? rec.current.stop() : state === "idle" && start());
  const Icon = state === "recording" ? Square : state === "busy" ? Loader2 : Mic;
  return (
    <button type="button" onClick={click} disabled={state === "busy"} data-testid="voice-input-btn" data-state={state}
      aria-label={state === "recording" ? "Stop recording" : "Talk"}
      className={`w-10 h-10 rounded-full grid place-items-center shrink-0 transition-colors ${state === "recording" ? "bg-[#C87D53] text-white animate-pulse" : "bg-[#E3EBE5] text-[#2C4A3E] hover:bg-[#d5e2d9]"} ${className}`}>
      <Icon className={`w-4 h-4 ${state === "busy" ? "animate-spin" : ""}`} />
    </button>
  );
};
